import { withProfiling } from '../self-measurements';
import { makeTraceHttpRequestHeaders } from './utils/make-trace-http-request-headers';
var state = {
  context: null
};
export var generateSpanId = withProfiling(function generateSpanId() {
  return Array.from(new Array(16), function () {
    return Math.floor(Math.random() * 16).toString(16);
  }).join('');
});
export var setInteractionActiveTrace = withProfiling(function setInteractionActiveTrace(interactionId, experienceType) {
  setActiveTrace(interactionId.replace(/-/g, ''), generateSpanId(), experienceType);
});
export var setActiveTrace = withProfiling(function setActiveTrace(traceId, spanId, type) {
  state.context = {
    traceId: traceId,
    spanId: spanId,
    type: type
  };
});
export var getActiveTrace = withProfiling(function getActiveTrace() {
  return state.context || undefined;
});
export var clearActiveTrace = withProfiling(function clearActiveTrace() {
  state.context = null;
});
export var getActiveTraceHttpRequestHeaders = withProfiling(function getActiveTraceHttpRequestHeaders(_url) {
  if (state.context === null) {
    return null;
  }
  var _state$context = state.context,
    traceId = _state$context.traceId,
    spanId = _state$context.spanId;
  return makeTraceHttpRequestHeaders(traceId, spanId);
});
export var getActiveTraceAsQueryParams = withProfiling(function getActiveTraceAsQueryParams(_url) {
  var traceHeaders = getActiveTraceHttpRequestHeaders(_url);
  return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
});